import Error from "../utils/Error.js";
import global from "../global.js";
import InputAdminPasswordArea from "./InputAdminPasswordArea.js";
import ConfirmationArea from "./ConfirmationArea.js";

const log = global.log.getLogger("f_mtac.ui.UserArea");
log.setLevel(log.levels.WARN);

const CURRENT_CLASS = "btn-mtac-btn-white";
const SELECTED_CLASS = "btn-mtac-btn-gray";
const DEFAULT_CLASS = "btn-mtac-btn-black";

let UserArea = function () {
    Object.defineProperty(this, "user_name", {
        set: () => {},
        get: () => {
            let name = $("#user_area input[name=user_name]").val() || global.internationalization.text("archive.anonymous");
            name = name.charAt(0).toUpperCase() + name.substr(1);
            return name;
        }
    });

    Object.defineProperty(this, "current_level", {
        set: (level) => {
            level ||= 2; // if falsy, use default level (standard)
            $("#user_area button[data-profile]").removeClass(CURRENT_CLASS).removeClass(SELECTED_CLASS).addClass(DEFAULT_CLASS); // Reset buttons default state
            $(`#user_area button[data-profile="${level}"]`).removeClass(DEFAULT_CLASS).addClass(CURRENT_CLASS); // Set current level button state
        },
        get: () => {
            const level = $(`#user_area button[data-profile].${CURRENT_CLASS}`).data("profile") || 0;
            return parseInt(level, 10);
        }
    });

    Object.defineProperty(this, "selected_level", {
        set: (level) => {
            $(`#user_area button[data-profile].${SELECTED_CLASS}`).removeClass(SELECTED_CLASS).addClass(DEFAULT_CLASS);
            $(`#user_area button[data-profile="${level}"]`).addClass(DEFAULT_CLASS).addClass(SELECTED_CLASS);
        },
        get: () => {
            const level = $(`#user_area button[data-profile].${SELECTED_CLASS}`).data("profile") || this.current_level;
            return parseInt(level, 10);
        }
    });

    var profile_level = (element) => parseInt(element.data("profile"), 10);

    const enable_controls = () => {
        $("#user_area button").prop("disabled", false);
        $("#user_area input").prop("disabled", false);
        // Agnet AGPOC-5842 : user name cannot be changed if user is a Agnet user
        if (global.configuration.user.agnet !== undefined) {
            $("#user_area input[name=user_name]").attr("disabled", true);
        }
    };

    const disable_controls = () => {
        $("#user_area button").prop("disabled", true);
        $("#user_area input").prop("disabled", true);
    };

    const enable_cancel_btn = () => {
        $("#user_area button[data-method='cancel']").css("visibility", "visible");
    };
    const disable_cancel_btn = () => {
        $("#user_area button[data-method='cancel']").css("visibility", "hidden");
    };

    var interaction = null;
    var interaction_end = () => {
        if (interaction === null) {
            return;
        }
        $("#user_area").hide();
        $("#user_area input[name=user_name]").removeClass("capitalized");
        $("#user_area button[data-profile]").removeClass(SELECTED_CLASS).addClass(DEFAULT_CLASS);
        if (interaction.error === null) {
            interaction.resolve(global.server.registrar.user);
        } else {
            interaction.reject(interaction.error);
        }
        interaction = null;
    };

    /**
     * @brief when click on any role change button, InputAdminPasswordArea modal appear
     */
    $("body").on("click.profile", "#user_area button[data-profile]", async (event) => {
        log.debug("ui.UserArea.click_profile");
        log.debug("event : ", event);
        let title = global.internationalization.text("user.change-profile");
        // create modal and wait for the user to click on a button, then use the resolve inside an anonymous function, checking if the password was correct and modifying the level if user save afterward.
        return InputAdminPasswordArea.interact({title}).then((authentification_confirmation) => {
            // if authentification_confirmation = 1 user is admin, 0 otherwise
            if (authentification_confirmation == 1) {
                this.selected_level = profile_level($(event.currentTarget));
                log.debug("new level : ", this.selected_level);
            }
        });
    });

    $("body").on("click", "#button-logout", async () => {
        log.debug("ui.UserArea.click button-logout");
        let confirmation = await ConfirmationArea.interact({
            title: global.internationalization.text("global.Warning"),
            tip1: global.internationalization.text("user.Confirm-logout")
        });
        if (confirmation) {
            log.debug("ui.UserArea.click confirmed");
            global.server.mtac_logout();
        }
    });

    $("body").on("click", "#user_area button.submit", async () => {
        let name = this.user_name;
        let level = this.selected_level;
        disable_controls();
        if (!("token" in global.server.registrar.user)) {
            await global.server.registrar.register_retry({name, level});
        }
        try {
            await global.server.registrar.update({name, level});
        } catch (error) {
            switch (error.status) {
                case Error.status.netdown:
                case Error.status.hostdown:
                    log.error("failed to update user, no connection");
                    break;
                case Error.status.access:
                    log.error("failed to update user, trying to re-register");
                    await global.server.registrar.register_retry({name, level});
                    break;
                default:
                    log.error("failed to update user, trying to re-register", error);
                    await global.server.registrar.register_retry({name, level});
                    break;
            }
        }

        // update language in Internationalization module (and renew translations)
        const selected_language = $("#select-language").val();
        await global.internationalization.changeLanguage(selected_language);

        interaction_end();
    });

    $("body").on("click", "#user_area button.cancel", () => {
        interaction_end();
    });

    // add the availabble languages in the select box
    async function fillLanguages() {
        let languages; // the list of languages got from the server
        // Get language list anytime (AGPOC-4207)+
        try {
            languages = await global.server.mtac_language_list();
        } catch (error) {
            log.error("error while fetching language list", error);
            return;
        }

        let select = $("#select-language");
        select.empty(); // Remove existing options
        let languages_list = Object.values(languages.data.list);
        languages_list.forEach((lang) => (lang.text = global.internationalization.text(`language.${lang.name}`)));
        languages_list.sort((a, b) => (a.text < b.text ? -1 : a.text > b.text ? 1 : 0));
        languages_list.forEach((lang) => $("<option>").attr("value", lang.name).text(lang.text).appendTo(select));
    }

    this.interact = async (enable_cancel) => {
        if (enable_cancel) {
            enable_cancel_btn();
        } else {
            disable_cancel_btn();
        }

        // Show the logout button only if AGNET
        if (global.server.registrar.user.agnet) {
            $("#btn_logout").show();
        } else {
            $("#btn_logout").hide();
        }

        // Prepare username input
        $("#user_area input[name=user_name]").addClass("capitalized");
        if (global.configuration.user.agnet !== undefined) {
            let name = global.users.get_agnet_user_name();
            $("#user_area input[name=user_name]").val(name);
        } else {
            $("#user_area input[name=user_name]").val(`${global.configuration.user.name}`);
        }

        // Prepare profile selector
        this.current_level = global.configuration.user.level;

        // Prepare language selector
        await fillLanguages();
        $("#select-language").val(global.configuration.internationalization.language);

        enable_controls();
        $("#user_area").show();
        $("#splash").hide();
        var promise = new Promise((resolve, reject) => {
            interaction = {promise, resolve, reject, error: null};
        });
        return promise;
    };
};

export default new UserArea();
